<template>
    <div id="setup-tab-general-container">
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('insuranceSetup.CompanyName')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'Company'"
                    v-model="editableItem.company"
                    v-bind:isReadOnly="!!editableItem.company"
                    v-bind:Id="'input_company'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Address1')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'address1'"
                    v-model="editableItem.address1"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_addrs1'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Address2')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'address2'"
                    v-model="editableItem.address2"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_addrs2'"
                />
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Phone')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="15"
                    v-bind:Name="'phone'"
                    v-model="editableItem.telephone"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_telephone'"
                />
            </b-col>
            
        </b-row>
        <b-row>
             <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Patient.LegalFax')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'fax'"
                    v-model="editableItem.fax"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_fax'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Country')"
                    v-bind:Options="CountryList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="CountryModel"
                    :IsDisabled="isReadOnly"
                    :Input="ChangeDropDownCountry"
                />
            </b-col>
            <b-col
                lg="3"
                md="3"
                sm="12"
                v-if="
                    this.$store.state.companies.Country ===
                        'United States' && isCountryUsa
                "
            >
                <MdSelect
                    v-bind:Label="$t('Shared.State')"
                    v-bind:Options="StateList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'state'"
                    v-bind:Model="editableItem.state"
                    v-bind:Tag="'State'"
                    v-bind:Multiple="false"
                    :IsDisabled="isReadOnly"
                    :Input="ChangeDropDownState"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12" v-else>
                <MdEdit
                    v-bind:Label="$t('Shared.State')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'state'"
                    v-bind:MaxLengthProp="20"
                    v-model="editableItem.state"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_contact_state'"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.City')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'city'"
                    v-model="editableItem.city"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_city'"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Zip')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'zip'"
                    v-model="editableItem.zip"
                    v-on:blur="insuranceZipBlur(editableItem.zip)"
                    v-on:change="insuranceZipChange($event)"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_zip'"
                />
            </b-col>
             <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$tc('Contact.Contact')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'contact'"
                    v-model="editableItem.contact"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_contact'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('providerSetup.eINNumber')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="20"
                    v-bind:Name="'eINNumber'"
                    v-model="editableItem.ein"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'inputeINNumber'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('companySetup.tabGeneral.labPulling')"
                    v-bind:Name="'timeInterval'"
                    v-bind:TypeProp="'number'"
                    v-model="editableItem.timeInterval"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'1'"
                    v-bind:Max="'10'"
                    v-bind:Id="'input_timeInterval'"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('employee.UserID')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="50"
                    v-bind:Name="'UserID'"
                    v-model="editableItem.userId"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input_insu_userid'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdRadioGroup
                    v-bind:Label="$t('companySetup.tabGeneral.comPort')"
                    v-model="editableItem.comport"
                    v-bind:Options="options"
                    v-bind:Name="'Comport'"
                    v-bind:isReadOnly="isReadOnly"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>


export default {
    name: 'TabGeneral',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        },
        CountryList: {
            Type: Array,
            default: () => []
        },
        StateList: {
            Type: Array,
            default: () => []
        },
    },
    data() {
        const defaultItemData = {
            address1: '',
            address2: '',
            city: '',
            company: '',
            comport: null,
            contact: '',
            country: '',
            ein: '',
            fax: '',
            state: '',
            telephone: '',
            zip: '',
            timeInterval: null,
            userId: '',
        };
        

        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData,
            StateModel: { name: '', state: '' },
            CountryModel: { recId: null, name: null },
            newpassword:'',
            confirmpassword:'',
            isNewPassvalid:true,
            isConfirmPassvalid:true,
            options: [
                { text: this.$t('Com 1'), value: 1 },
                { text: this.$t('Com 2'), value: 2 },
                { text: this.$t('Com 3'), value: 3 },
                { text: this.$t('Com 4'), value: 4 }
            ],
            isCountryUsa:true 
        };
    },
    watch: {
        value(newVal) {
            this.editableItem = newVal || this.defaultItemData;

            
            this.CountryModel.code = this.editableItem?.country || '';
            this.CountryModel.name = this.editableItem?.country || '';
            this.editableItem.comport = (this.editableItem.comport).toString();

            this.isCountryUsa = this.CountryModel.name != 'United States' ? false : true;
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        },
        
        ChangeDropDownCountry(item) {
            this.CountryModel = item ? item : { recId: '', name: '' };
            this.editableItem.country = this.CountryModel.name;
            this.isCountryUsa = this.CountryModel?.name != 'United States' ? false : true;
        },

        ChangeDropDownState(item) {
            this.editableItem.state = item ? item.state : null;
        },

        comparePassword() {
            if(this.newpassword === this.confirmpassword) {
                return true
            }
            return false
        },

        EndFunction(){
            this.changePassword();
        },

        validate_required() {
            this.isNewPassvalid = this.newpassword.length > 0 ? true : false;      
            this.isConfirmPassvalid =  this.confirmpassword.length > 0 ? true : false; 
            return this.isNewPassvalid && this.isConfirmPassvalid;
        },

    }
};
</script>
